import * as React from 'react';

import { LazyImageContext } from '../components/LazyImage/LazyImageContext';

export function useLazyImage(): [((node: HTMLImageElement | null) => void) | null] {
    const values = React.useContext(LazyImageContext);
    return [values.handleRef];
}
